<div style="text-align: center;">
    <h1>QUOTE {{quote.quoteNumber}} @if (quote.quoteRevision > 0){(Revision {{quote.quoteRevision}})}</h1>
    Created: {{quote.dtCreated+'Z' | date:'dd MMM yyyy HH:mm'}}
</div>
<nz-divider></nz-divider>
<div nz-row [nzJustify]="'center'">
    <div nz-col [nzSpan]="8">
        Seller: {{quote.sellerName}}<br />
        For: {{quote.clientName}}
    </div>
    <div nz-col [nzSpan]="8">
        Driver: {{quote.driver.name}} ({{quote.driver.phoneNumber}})<br />
        Distance: {{quote.incidentDistance}} km
    </div>
    <div nz-col [nzSpan]="8" style="text-align: right;">
        Vehicle: {{quote.incidentVehicle.registrationNumber}}
    </div>
</div>

